import React from 'react';
import {css} from '@emotion/react';
import theme from '../../www/theme';

export default function Checkbox({checked, onChange}) {
  return (
    <>
      <input type="checkbox" css={css`display: none`} />
      <span tabIndex="0" css={css`
        border: 1px solid ${checked ? theme.colors.primary : '#999'};
        border-radius: 2px;
        width: 16px;
        height: 16px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background-color: ${checked ? theme.colors.primary : 'transparent'};
        color: ${checked ? 'white' : theme.colors.primary};
        font-size: 12px;
        cursor: pointer;
        font-weight: bold;
      `} className="material-icons" onClick={ () => onChange(!checked) }>
        {checked ? 'check' : ''}
      </span>
    </>
  );
};
